export default "__VITE_ASSET__CXBvA5_H__"